import { useState } from "react";
import { FiLock } from "react-icons/fi";
import api from "../api";
import { useSuccessFailure } from "../context/SuccessFailureContext";
import { Button, Input, Card } from "./ui";

const ChangePasswordCard = () => {
  const { showSuccessModal, showFailureModal } = useSuccessFailure();
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) return showFailureModal("Weak password", "New password must be at least 8 characters.");
    if (form.new_password !== form.confirm) return showFailureModal("Mismatch", "New passwords do not match.");
    setSaving(true);
    try {
      await api.post("/users/change-password/", {
        old_password: form.old_password, new_password: form.new_password,
      });
      setForm({ old_password: "", new_password: "", confirm: "" });
      showSuccessModal("Password changed", "Your password has been updated.");
    } catch (err) {
      showFailureModal("Failed", err.response?.data?.error || "Could not change password.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="mb-6">
      <div className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <FiLock className="w-5 h-5 text-indigo-600" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Change password</h2>
        </div>
        <form onSubmit={submit} className="space-y-3 max-w-md">
          <Input type="password" label="Current password" value={form.old_password} onChange={set("old_password")} required />
          <Input type="password" label="New password" value={form.new_password} onChange={set("new_password")} required />
          <Input type="password" label="Confirm new password" value={form.confirm} onChange={set("confirm")} required />
          <Button type="submit" loading={saving}>Update password</Button>
        </form>
      </div>
    </Card>
  );
};

export default ChangePasswordCard;
